export const SNAPENGAGE_CODES = {
  CX: 'e8b7e799-a477-471f-be4d-be1dab02f966',
};

export const CHAT_STYLE = `
.chat-admaker .prechat-header,
.chat-admaker #prechat-start-chat,
.chat-admaker .chat-header,
.chat-admaker #action-item-menu li:hover, #action-item-menu li:focus,
.chat-admaker .btn-primary {
  background-color: black !important;
  color: white !important;
  font-weight: 900;
}
.chat-admaker #comments-o path,
.chat-admaker #minimize_thin path,
.chat-admaker #close_thin path,
.chat-admaker .designstudio-icon path{
  fill: white !important;
}
.`;

export const IFRAMES = {
  CHAT: {
    iFrameId: 'designstudio-iframe',
    styleCss: {
      classId: 'chat-admaker',
      class: CHAT_STYLE,
    }
  },
};
